<template>
  <div>
    <div class="select-container clearfix" style="margin-top: 2%;">
      <el-form :model="moaAccessWhiteApply" :rules="checkNull" ref="ruleForm" class="demo-ruleForm"
               label-width="250px">
        <div style="margin-left: 23%;"><span style="color:red">请务必真实填写个人信息，否则将影响安全防护效果！</span></div>
        <div style="margin-left: 10%;margin-bottom: 15px"><span style="color:red">( Please be sure to fill in your personal information truthfully, otherwise it will affect the security protection effect! )</span></div>
        <el-form-item label="账号 ( Mis ) :" style="width: 60%;" prop="misId">
          <el-input v-model="moaAccessWhiteApply.misId" disabled placeholder="账号 ( Mis )"></el-input>
        </el-form-item>
        <el-form-item label="加白场景 ( Whiten the scene ):" required prop="scene">
          <el-radio-group v-model="moaAccessWhiteApply.scene">
            <el-radio :label="1"> 短期加白( Short term whitening ) </el-radio>
            <el-radio :label="2"> 长期加白( Long term whitening ) </el-radio>
          </el-radio-group>
        </el-form-item>
        <el-form-item v-if="moaAccessWhiteApply.scene == 2" required label="加白到期时间( The expiration date for the whitelist ):">
          <el-date-picker type="date" value-format="yyyy-MM-dd" v-model="moaAccessWhiteApply.dateLine" placeholder="选择时间" :picker-options="dateLineOptions"/>
        </el-form-item>
        <el-form-item label="操作系统 ( System ):" required>
          <el-checkbox-group v-model="moaAccessWhiteApply.deviceOsList" placeholder="请选择">
            <el-checkbox :label="1"> PC端: macOS（需要说明不能按照要求安装合规软件的原因） ( PC: macOS, the reason why compliant software cannot be installed as required needs to be explained )</el-checkbox>
            <el-checkbox :label="2"> PC端: Windows（需要说明不能按照要求安装合规软件的原因）( PC: Windows, you need to explain why you cannot install compliant software as required ) </el-checkbox>
<!--            <el-checkbox :label="5"> PC端: Linux（Ubuntu系统无需申请，直接安装MOA可入网，安装方式参考https://km.sankuai.com/page/1359685388，其它操作系统如无法安装可以申请加白）( PC: Linux, Ubuntu systems do not require application; simply install MOA to access the network. For installation instructions, refer to the https://km.sankuai.com/page/1359685388. For other operating systems, if installation is not possible, you can apply for whitelisting ) </el-checkbox>-->
<!--            <el-checkbox :label="3"> 移动端: iOS ( Mobile: iOS )</el-checkbox>-->
<!--            <el-checkbox :label="4"> 移动端: Android ( Mobile：Android ) </el-checkbox>-->
            <el-checkbox :label="7"> 其他 ( other ) </el-checkbox>
          </el-checkbox-group>
        </el-form-item>
        <el-form-item label="申请安全准入加白项目 ( Access Whitelist Application ):" required>
          <el-checkbox-group v-model="moaAccessWhiteApply.items" placeholder="请选择">
            <el-checkbox :label="1"> MOA不安装加白 ( MOA not installed, add white ) </el-checkbox>
            <el-checkbox :label="2"> 杀毒软件不安装加白 ( Add whitelist if antivirus software is not installed ) </el-checkbox>
            <el-checkbox :label="3"> 数据防泄漏不安装加白 ( Data leak prevention without installation and whitelisting ) </el-checkbox>
            <el-checkbox :label="4"> MDM不安装加白 ( MDM not installed, add white ) </el-checkbox>
            <el-checkbox :label="5"> 不合规软件不卸载加白 ( Unregister non-compliant software and add it to the whitelist ) </el-checkbox>
            <el-checkbox :label="6"> 其他 ( other ) </el-checkbox>
          </el-checkbox-group>
        </el-form-item>
        <el-form-item label="申请原因 ( Reason for application ) :" prop="reason" style="width: 60%;">
                <textarea maxlength=2000 placeholder="申请原因 ( Reason for application )"
                          style="width:98%;height:100px;border:solid 1px #C0C0C0; border-radius:3px; resize:none;"
                          v-model="moaAccessWhiteApply.reason"></textarea>
        </el-form-item>
        <div style="margin-left: 35%;">
          <el-button type="primary" @click="commitMisApply(moaAccessWhiteApply)"> 提交审批 ( Submit for approval )</el-button>
        </div>
      </el-form>
    </div>

  </div>
</template>

<script>
import store from '../vuex/service/store'
import axios from 'axios'
import {mapState} from 'vuex';

export default {
  store: store,
  mounted: function () {
    var vm = this;
    if (vm.token == "") {
      var token = this.getCookie("access-token");
      if (token != null) {
        vm.$store.commit('UPDATETOKEN', token);
        vm.token = token;
      }
    }
    vm.getUser();
  },
  computed: mapState({
    loginRediret: function (state) {
      return state.loginRediret;
    },
    cookieName: function (state) {
      return state.cookieName;
    },
    addWhiteListAPI: function (state) {
      return state.addWhiteListAPI;
    },
    getuserAPI: function (state) {
      return state.getuserAPI;
    }
  }),
  methods: {
    getCookie(name) {
      var arr, reg = new RegExp("(^| )" + name + "=([^;]*)(;|$)");
      if (arr = document.cookie.match(reg))
        return unescape(arr[2]);
      else
        return null;
    },
    commitMisApply(doc) {
      var vm = this;
      if (doc.misId == null || doc.misId == "") {
        alert("Mis账号不能为空 ( Mis cannot be empty )");
        return;
      }
      if (doc.scene == 2 && doc.dateLine == null) {
        alert("加白到期时间不能为空 ( The expiration date for the whitelist cannot be empty )");
        return;
      }
      if (doc.deviceOsList.length == 0) {
        alert("操作系统不能为空 ( The system cannot be empty )");
        return;
      }
      if (doc.items.length == 0) {
        alert("加白项目不能为空 ( The whitelist program cannot be empty )");
        return;
      }
      if (doc.reason == null || doc.reason.trim() == "") {
        alert("原因不能为空 ( The reason cannot be empty )");
        return;
      }
      const param = {
        ...doc,
        deviceOsList: doc.deviceOsList.join(';'),
        items: doc.items.join(';')
      };
      axios.post(vm.addWhiteListAPI, param, {
        withCredentials: true
      }).then((response) => {
        var status = response.data.code;
        var message = response.data.message;

        if (status === 0) {
          // status为0时显示成功消息与可点击的超链接
          var link = message; // message就是审批链接URL
          var successMessage = `
            <div style="text-align: left; line-height: 1.8; font-size: 14px;">
              <div style="margin-bottom: 10px; font-weight: 600;"> 提交成功 / Submitted successfully </div>
              <div style="margin-bottom: 10px;"> 审批详情 / Approval details：</div>
              <div style="margin-bottom: 10px;"><a href="${link}" target="_blank" style="color: #409EFF; text-decoration: underline; cursor: pointer;">${link}</a></div>
              <div> 若无法访问，请在手机大象查看 / If inaccessible, check in DaXiang app. </div>
            </div>
          `;
          vm.$alert(successMessage, '提示', {
            dangerouslyUseHTMLString: true,
            confirmButtonText: '确定',
            callback: () => {
              // 重置表单数据
              vm.moaAccessWhiteApply.scene = 1;
              vm.moaAccessWhiteApply.dateLine = null;
              vm.moaAccessWhiteApply.deviceOsList = [];
              vm.moaAccessWhiteApply.items = [];
              vm.moaAccessWhiteApply.reason = '';
            }
          });
        } else {
          // 处理换行，然后提取message中的链接
          var urlRegex = /(https?:\/\/[^\s<>]+)/g;
          var displayMessage = message.replace(/\n/g, '<br/>').replace(urlRegex, function(url) {
            return `<a href="${url}" target="_blank" style="color: #409EFF; text-decoration: underline; cursor: pointer;">${url}</a>`;
          });
          var errorMessage = `<div style="text-align: left; line-height: 1.8; font-size: 14px;">${displayMessage}</div>`;
          vm.$alert(errorMessage, '提示', {
            dangerouslyUseHTMLString: true,
            confirmButtonText: '确定',
            callback: () => {
              // 重置表单数据
              vm.moaAccessWhiteApply.scene = 1;
              vm.moaAccessWhiteApply.dateLine = null;
              vm.moaAccessWhiteApply.deviceOsList = [];
              vm.moaAccessWhiteApply.items = [];
              vm.moaAccessWhiteApply.reason = '';
            }
          });
        }
      }).catch(function (error) {
        vm.requesterrorinfo(error);
      })
    },
    getUser() {
      var vm = this;
      if (vm.user == null || vm.user == "") {
        vm.user = vm.getCookie("username");
        document.cookie = "ssoid=" + vm.getCookie("access-token");
        axios.get(vm.getuserAPI, {
          withCredentials: true
        }).then((response) => {
          if (response.data.status == 401) {
            document.cookie = vm.cookieName + vm.$route.fullPath;
            window.location = vm.loginRediret;
          } else {
            vm.moaAccessWhiteApply.misId = response.data.data.login;
            if (vm.moaAccessWhiteApply.misId == null) {
              vm.moaAccessWhiteApply.misId = vm.getCookie("username");
            }
            if (vm.moaAccessWhiteApply.misId == null) {
              vm.moaAccessWhiteApply.misId = vm.getCookie("user").login;
            }
          }
        }).catch(function (error) {
          vm.requesterrorinfo(error)
        })
      }
    },
    requesterrorinfo(error) {
      var vm = this;
      if (error.response) {
        var code = error.response.status;
        if (code == 401) {
          vm.$message.error("401:您未登录");
          var count = vm.getCookie("access-count")
          window.location = vm.loginRediret;
          if (count == null || count == 0) {
            document.cookie = "access-count=1";
            vm.$message('您未登录,请刷新');
            document.cookie = vm.cookieName + vm.$route.fullPath;
            window.location = vm.loginRediret;
          } else {
            vm.$message('您未登录,请刷新');
          }
        } else {
          if (code == 404) {
            vm.$notify({
              title: '提示',
              message: '404:Not found!',
              type: 'error'
            });
          } else {
            vm.$notify({
              title: '提示',
              message: '501:服务端未响应!',
              type: 'error'
            });
          }
        }
      } else {
        vm.$notify({
          title: '提示',
          message: '502:服务端未响应!',
          type: 'error'

        });
      }
    }
  },
  data() {
    return {
      token: '',
      dateLineOptions: {
        disabledDate (date) {
          // 只禁用今天之前的日期，允许选择今天
          const today = new Date();
          today.setHours(0, 0, 0, 0);
          return date && date.getTime() < today.getTime();
        },
      },
      moaAccessWhiteApply: {
        misId: '',
        dateLine: null,
        scene: 1,
        deviceOsList: [],
        items: [],
        reason: ''
      },
      checkNull: {
        misId: [{required: true, message: 'MIS账号不能为空', trigger: 'blur'}, {
          min: 1,
          max: 50,
          message: '长度在 50 个字以内',
          trigger: 'blur'
        }],
        // scene: [
        //   {
        //     required: true,
        //     message: '请选择加白场景',
        //     trigger: 'change'
        //   }
        // ],
        // deviceOsList: [
        //   {
        //     required: true,
        //     validator: (rule, value, callback) => {
        //       if (!value || value.length === 0) {
        //         callback(new Error('请至少选择一个操作系统'));
        //       } else {
        //         callback();
        //       }
        //     },
        //     trigger: 'change'
        //   }
        // ],
        // items: [
        //   {
        //     required: true,
        //     validator: (rule, value, callback) => {
        //       if (!value || value.length === 0) {
        //         callback(new Error('请至少选择一个加白项目'));
        //       } else {
        //         callback();
        //       }
        //     },
        //     trigger: 'change'
        //   }
        // ],
        reason: [{required: true, message: '申请原因不能为空', trigger: 'blur'}, {
          min: 1,
          max: 1000,
          message: '长度在 200 个字以内',
          trigger: 'blur'
        }],
      },
    }
  }
}

</script>
<style scoped>

.demo-table-expand label {
  width: 140px;
  color: #5d94bf;
}

.clearfix:after {
  content: '';
  display: block;
  visibility: hidden;
  clear: both;
}

.select-container {
  padding: 15px 0px 3px;
}

.select-left {
  float: left;
  display: table;
}

.select-left > div {
  vertical-align: top;
}

.select-left > div:not(:last-child) {
  margin-right: 5px;
}

.select-right {
  float: right;
}

textarea {
  border: 1px solid #5d94bf;
  background-color: transparent;
  /*scrollbar-arrow-color:yellow;
  scrollbar-base-color:lightsalmon;
  overflow: hidden;*/
/ / color: #666464;
  height: auto;
  resize: none;
  border-left: 1px solid #5d94bf;
  border-right: 1px solid #5d94bf;
  border-top: 1px solid #5d94bf;
  border-bottom: 1px solid #5d94bf;
}

.el-form-item {
  margin-bottom: 10px; /* 默认是20px，可以减少 */
}

.el-checkbox {
  display: flex; /* 或者使用 flex 布局 */
  align-items: flex-start;
  white-space: normal; /* 允许换行 */
  margin-bottom: 8px;
}

.el-checkbox__label {
  display: flex;
  align-items: flex-start;
  gap: 8px;
}

</style>



// WEBPACK FOOTER //
// whiteApply.vue?7ba668d0